// 
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Row, Col, Icon, Divider, Tabs, Spin } from 'antd'
import { getCookie } from '../../hook';
import './style.css';

// Child
import AnnualLeaveSummary from './childs/leavesummary';
import SickLeaveSummary from './childs/sick_leave_summary';
import CompassionateLeaveSummary from './childs/comp_leave_summary';
import WeddingLeaveSummary from './childs/wedding_leave_summary';
import EmergencyLeaveSummary from './childs/emergency_leave_summary';
import EmployeeData from './childs/employee_data';
import WorkHomeLeaveSummary from './childs/workfhome_summary';

// Actions
import { get_leave_summary, get_company } from './actions/reports.action';

const TabPane = Tabs.TabPane;

class Reports extends Component {

    constructor( props ){

        super( props );

        this.state = {
            annual_leave_data: [],
            sick_leave_data: [],
            compassionate_leave_data: [],
            wedding_leave_data: [],
            emergency_leave_data: [],
            workhome_leave_data: [],
            employee_data: [],
            company_list: [{ text: 'None', value: 'None' }],
            loading: false
        }

        this.handleTabs = this.handleTabs.bind( this );

    }

    componentWillMount(){

        this.setState({ loading: true })

        let user = getCookie('dv_hrms_user').split(',');
        let user_id =  user[6];

        // get leave summary
        this.props.get_leave_summary( user_id );
        this.props.get_company();

    }

    componentWillReceiveProps( props ){

        if( props.reports.length != 0 ){

            if( props.reports.STATUS.CODE === "200" && 
                props.reports.STATUS.MESSAGE === "Successfully Listed Leaves" ){

                    this.setState({
                        annual_leave_data: props.reports.OUTPUT.DATA.annual_leave_summary,
                        sick_leave_data: props.reports.OUTPUT.DATA.sick_leave_summary,
                        compassionate_leave_data: props.reports.OUTPUT.DATA.compassionate_leave_summary,
                        wedding_leave_data: props.reports.OUTPUT.DATA.wedding_leave_summary,
                        emergency_leave_data: props.reports.OUTPUT.DATA.emergency_leave_summary,
                        workhome_leave_data: props.reports.OUTPUT.DATA.workhome_leave_data,
                        employee_data: props.reports.OUTPUT.DATA.get_employee_data,
                        loading: false
                    });

            } else if( props.reports.STATUS.CODE === "200" && 
                props.reports.STATUS.MESSAGE === "Successfully Listed Company" ){
                    
                let data_temp = [];
            
                props.reports.OUTPUT.DATA.map( (item, k) => {
                    data_temp.push( { text: item.company_name, value: item.company_name } );
                });
        
                this.setState({
                    company_list: data_temp
                });
            
            }
        
        }
    
    }

    handleTabs( key ){
        let user = getCookie('dv_hrms_user').split(',');
        var user_id =  user[6];

        this.props.get_leave_summary( user_id );

    }

    render() {
        return (
            <div className="reports_wrapper">
                <Row gutter={16}>
                    <Col span={12}>
                        <h2>
                            <Icon type="printer" />
                            &nbsp; Reports 
                        </h2>
                    </Col>
                </Row>
                
                <Divider />

                <Row gutter={16}>
                    <Col span={24}>

                    <Spin spinning={this.state.loading}>

                        <Tabs defaultActiveKey="a" onChange={ this.handleTabs }>
                            
                            <TabPane tab="Leave Summary" key="a" >

                                <Tabs defaultActiveKey="1" >
                                    <TabPane tab="Annual Leave Summary" key="1">
                                        <AnnualLeaveSummary onCompany={ this.state.company_list } onData={ this.state.annual_leave_data } />
                                    </TabPane>
                                    <TabPane tab="Sick Leave Summary" key="2">
                                        <SickLeaveSummary onCompany={ this.state.company_list } onData={ this.state.sick_leave_data } />
                                    </TabPane>
                                    <TabPane tab="Compassionate Leave Summary" key="3">
                                        <CompassionateLeaveSummary onCompany={ this.state.company_list } onData={ this.state.compassionate_leave_data } />
                                    </TabPane>
                                    <TabPane tab="Wedding Leave Summary" key="4">
                                        <WeddingLeaveSummary onCompany={ this.state.company_list } onData={ this.state.wedding_leave_data } />
                                    </TabPane>
                                    <TabPane tab="Emergency Leave Summary" key="5">
                                        <EmergencyLeaveSummary onCompany={ this.state.company_list } onData={ this.state.emergency_leave_data } />
                                    </TabPane>
                                    <TabPane tab="Work From Home Summary" key="6">
                                        <WorkHomeLeaveSummary onCompany={ this.state.company_list } onData={ this.state.workhome_leave_data } />
                                    </TabPane>
                                </Tabs>
                                
                            </TabPane>
                            <TabPane tab="Employee Information" key="b">
                                <EmployeeData onCompany={ this.state.company_list } onData={ this.state.employee_data } />
                            </TabPane>
                        </Tabs>

                        
                        </Spin>
                        
                    </Col>
                </Row>
            </div>
        )
    }
}

function mapStateToProps( state ) {
    return {
        reports: state.reports
    }
}

export default connect( mapStateToProps, { get_leave_summary, get_company } )( Reports );


// WEBPACK FOOTER //
// ./src/pages/reports/index.js